import { MAXIMUM_MW_PER_PTU } from '@/features/bessDashboard/constants'

export const isCapacityValid = (value: string): boolean => {
  const isValidNumber = /^\d+\.?\d?$/.test(value)

  return isValidNumber && Number(value) >= 0 && Number(value) <= MAXIMUM_MW_PER_PTU
}
